import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { apiRequest } from "../api/apiClient.js";
import type { components } from "../../generated/api.js";

export type MeDTO = components["schemas"]["MeDTO"];
export type MembershipDTO = components["schemas"]["MembershipDTO"];
export type InternalTenantDTO = components["schemas"]["InternalTenantDTO"];

/**
 * Wer bin ich und was darf ich. Aus dieser Antwort wählt die Oberfläche ihre Shell und
 * ihre Rollenfarbe — nicht aus einem Theme-Schalter (StyleGuide 2.6).
 */
export function useMe(enabled: boolean): UseQueryResult<MeDTO> {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => apiRequest<MeDTO>("/me"),
    enabled,
  });
}
